import { z } from 'zod';

export const bookingCodePrefixSchema = z.object({
  prefix: z
    .string()
    .refine(
      (value) => value === '' || /^[A-Z0-9]{1,6}$/.test(value),
      'Prefiks może zawierać tylko wielkie litery i cyfry (max 6 znaków)',
    ),
});

export type BookingCodePrefixFormData = z.infer<typeof bookingCodePrefixSchema>;
